module.exports = __webpack_public_path__ + "img/deleteAnnonce.9f1be19b.svg";